let swiper = null;

export function setSwiperInstance(instance) {
  swiper = instance;
}

export function getSwiperInstance() {
  return swiper;
}
